<template>
  <div class="container">
    <div class="row">
      <div class="col text-center">
        <span class="text-muted">©{{ year }} Sense Company International</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
